// extracted by mini-css-extract-plugin
module.exports = {"home":"style-module--home--1WvbX","companyLogo":"style-module--company-logo--2PimL","introduction":"style-module--introduction--3aVz7"};